import { styled } from "@mui/material";

interface IProps {
	title: string;
}

const UploadHeader = (props: IProps) => {
  const { title } = props;

  return (
    <Container>
      <h3>{title}</h3>
    </Container>
  );
};

export default UploadHeader;

const Container = styled("div")({
  width: "100%",
  "& h3": {
    color: "white",
    fontWeight: 500,
    fontSize: "20px"
  },
  "@media screen and (max-width: 767px)": {
    display: "none"
  }
});
